<template>
  <div>
    <div class="box-cards" v-for="(limit, index) in newLimits" :key="index">
      <div>
        <div class="box-card-limite-global">
          <v-card class="box-card-global">
            <v-card-title>
              <v-layout>
                <v-flex>Limite Global do Tomador</v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="card-height">
              <div class="card-g" v-if="showSimpleModal">
                <div>
                  <h4>Situação Cadastral</h4>
                  <p>
                    {{
                      isAprovedDate(
                        limit.data_validade_limite,
                        limit.situacao_ativo
                      )
                    }}
                  </p>
                </div>
                <div>
                  <h4>Data de Validade</h4>
                  <p v-if="limit.data_validade_limite">
                    {{ formatDate(limit.data_validade_limite) }}
                  </p>
                  <p v-else>{{ msgValuesNull[2] }}</p>
                </div>
                <div>
                  <h4>Valor Total Acumulado</h4>
                  <p v-if="limit.limite_tomado">
                    {{ toMoneyString(limit.limite_tomado) }}
                  </p>
                  <p v-else>{{ msgValuesNull[1] }}</p>
                </div>
              </div>
              <div class="card-g" v-if="showDetailsModal">
                <div>
                  <h4>Situação Cadastral</h4>
                  <p v-if="limit.situacao_ativo">
                    {{
                      isAprovedDate(
                        limit.data_validade_limite,
                        limit.situacao_ativo
                      )
                    }}
                  </p>
                </div>
                <div>
                  <h4>Data de Validade</h4>
                  <p v-if="limit.data_validade_limite">
                    {{ formatDate(limit.data_validade_limite) }}
                  </p>
                  <p v-else>{{ msgValuesNull[2] }}</p>
                </div>

                <div>
                  <h4>Limite de Crédito Aprovado</h4>
                  <p v-if="limit.limite_disponivel">
                    {{
                      toMoneyString(
                        limit.limite_disponivel + limit.limite_tomado
                      )
                    }}
                  </p>
                  <p v-else>{{ msgValuesNull[1] }}</p>
                </div>
                <div>
                  <h4>Limite de Crédito Disponível</h4>
                  <p v-if="limit.limite_disponivel">
                    {{ toMoneyString(limit.limite_disponivel) }}
                  </p>
                  <p v-else>{{ msgValuesNull[1] }}</p>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <div class="box-button-global" v-if="showButton">
            <button
              id="jns"
              class="btn-primary jns-button yellow-button btn-att-cad"
              @click="getTaker()"
            >
              Atualizar Crédito
            </button>
          </div>

          <div class="box-msg-global" v-if="showCardMsg">
            <p>
              Não foi possível conceder automaticamente, o limite de crédito e a
              taxa do tomador. Caso tenha uma demanda, prossiga normalmente com
              a inclusão da proposta.
            </p>
          </div>
        </div>

        <!-- Tabelas de Limite por Modalidade -->
        <div v-if="sublimitsExists(sublimits)">
          <v-card v-if="showCardGm">
            <v-card-title>
              <v-layout row wrap>
                <v-flex xs12>Limite por Grupo de Modalidade</v-flex>
              </v-layout>
            </v-card-title>

            <v-card-text class="card-height">
              <div class="layout" v-if="showCardSimpleGm">
                <v-data-table
                  v-if="sublimits"
                  :headers="headesSimpleGm"
                  :items="sublimits"
                  :pagination.sync="pagination"
                  :rows-per-page-items="[10, 20]"
                  :loading="loading"
                  :no-data-text="'Nenhum limite encontrado.'"
                  :rows-per-page-text="'Linhas por página'"
                  class="tablec class-on-data-table"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td
                        class="text-xs-left"
                        style="max-width: 550px; width: 470px; min-width: 460px"
                      >
                        {{ props.item.nome }}
                      </td>

                      <td class="text-xs-left">
                        {{
                          notNegative(
                            toMoneyString(props.item.limite_disponivel)
                          )
                        }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>

              <div class="layout" v-if="showCardDetailsGm">
                <v-data-table
                  v-if="sublimits"
                  :headers="headesDetailsGm"
                  :items="sublimits"
                  :pagination.sync="pagination"
                  :rows-per-page-items="[10, 20]"
                  :loading="loading"
                  :no-data-text="'Nenhum limite encontrado.'"
                  :rows-per-page-text="'Linhas por página'"
                  class="tablec class-on-data-table"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td
                        class="text-xs-left"
                        style="max-width: 550px; width: 470px; min-width: 460px"
                      >
                        {{ props.item.nome }}
                      </td>

                      <td class="text-xs-left">
                        {{
                          notNegative(toMoneyString(props.item.limite_total))
                        }}
                      </td>

                      <td class="text-xs-left">
                        {{
                          notNegative(
                            toMoneyString(props.item.limite_disponivel)
                          )
                        }}
                      </td>

                      <td
                        class="text-xs-left"
                        v-if="props.item.taxa_segurado_privado"
                      >
                        {{
                          addPercent(
                            notNegative(props.item.taxa_segurado_privado)
                          )
                        }}
                      </td>

                      <td class="text-xs-left" v-else>
                        {{ msgValuesNull[0] }}
                      </td>

                      <td
                        class="text-xs-left"
                        v-if="props.item.taxa_segurado_publico"
                      >
                        {{
                          addPercent(
                            notNegative(props.item.taxa_segurado_publico)
                          )
                        }}
                      </td>

                      <td class="text-xs-left" v-else>
                        {{ msgValuesNull[0] }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { VMoney } from "v-money";
import { formatCNPJ, formatDate, toMoneyString, formatCNPJAndCPF, addPercent } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "TomadorLimitesTaxas",
  mixins: [ViewMixin],
  props: ["idTomador"],
  data: ()=> ({
    taker: null,
    formatCNPJ,
    formatDate,
    toMoneyString,
    formatCNPJAndCPF,
    addPercent,
    newLimits: [],
    sublimits: [],
    takerCNPJ: null,
    showCardMsg: null,
    showButton: null, 
    showCardGm: null,
    showCardSimpleGm: null,
    showCardDetailsGm: null,
    showSimpleModal: null,
    showDetailsModal: null,
    msgValuesNull: ['-', 'Não possuí', "Não cadastrado"],
    loading: false,
    pagination: {},
    headesSimpleGm: [
      {
        text: "Descrição por Grupo",
        align: "left",
        sortable: false,
      },
      {
        text: "Valor Acumulado",
        align: "left",
        sortable: false,
      },
    ],
    headesDetailsGm: [
      {
        text: "Descrição por Grupo",
        align: "left",
        sortable: false,
      },
      {
        text: "Limite Crédito Aprovado",
        align: "left",
        sortable: false,
      },
      {
        text: "Limite Crédito Disponível",
        align: "left",
        sortable: false,
      },
      {
        text: "Taxa Setor Privado",
        align: "left",
        sortable: false,
      },
      {
        text: "Taxa Setor Público",
        align: "left",
        sortable: false,
      },
    ],
  }),

  mounted() {
    this.takerCNPJ = this.$route.params.takerCNPJ;
    this.init();
  },

  methods: {
    init(){
      this.showLoadingAskWait();
      let promises = [this.getLimitsAndFeesByCNPJ()];
      Promise.all(promises).then(() => {
        this.hideLoadingAskWait();
        this.sublimits = this.mapSubLimits(this.newLimits);
        this.showRuleStatusAproved(this.newLimits[0].data_validade_limite, this.newLimits[0].limite_disponivel, this.newLimits[0].situacao_ativo);
      })
    },

    sublimitsExists(sublimites) {
      if(sublimites.length === 0) {
        return false;
      }
      return true;
    },

    async getLimitsAndFeesByCNPJ() {
      try {
        this.newLimits = await this.$store.dispatch("GET_TAKER_DATA", {
          cnpj: this.takerCNPJ,
        });
        this.$forceUpdate();
      } catch (e) {
        console.warn(e);
      } finally {
      }
    },

    async getTaker() {
      let limitsInfo;
      try {
        this.showLoadingAskWait();
        limitsInfo = await this.$store.dispatch("GET_TAKER_LIMITES", {
          id: this.idTomador,
        });
        this.newLimits = [limitsInfo]
        this.sublimits = this.mapSubLimits(this.newLimits);
        this.showRuleStatusAproved(this.newLimits[0].data_validade_limite, this.newLimits[0].limite_disponivel, this.newLimits[0].situacao_ativo);
      } catch (e) {
        if (e.data) {
          if (e.data.code == "4054") {
            this.handlerErrors(e);
            return;
          } else {
            if (e.code) {
              if (e.code == "4054") {
                this.handlerErrors(e);
                return;
              }
            } else {
              this.handlerErrors(e);
              return;
            }
          }
        } else {
          this.handlerErrors(e);
          return;
        }
      } finally {
        this.hideLoadingAskWait();
        }
      await this.$nextTick();
      this.$forceUpdate();
    },

    isAprovedDate(date, isAproved){
      if(isAproved){
        return 'Aprovado';
      }else {
        if(this.formatDateVigence(date)){
          return 'Negado';
        }else if(this.formatDateVigence(date) === false){
          return 'Expirado';
        }
        return '-';
      }
    },

    mapSubLimits(array){
      let sublimites = array.map(a => a.grupos_credito);
      return sublimites[0];
    },

    notNegative(val){
      let valStr = val.toString();
      let newVal = valStr.replace('-', '')
      return newVal;
    },

    showRuleStatusAproved(date, limite, aproved){
      let isCurrent = this.formatDateVigence(date);

      if(aproved){
        if(isCurrent && (limite === 0 || limite === null)){
          this.showCardMsg = true;
          this.showCardGm = false;
          this.showCardDetailsGm = false;
          this.showCardSimpleGm = false;
          this.showButton = false; 
          this.showSimpleModal = true;
          this.showDetailsModal = false; 
        }
        if(isCurrent && limite > 0){
          this.showCardMsg = false;
          this.showCardGm = true;
          this.showCardDetailsGm = true;
          this.showCardSimpleGm = false;
          this.showButton = false;
          this.showSimpleModal = false;
          this.showDetailsModal = true; 
        }
        if(!isCurrent){
          this.showCardMsg = false;
          this.showCardGm = true;
          this.showCardDetailsGm = false;
          this.showCardSimpleGm = true;
          this.showButton = true;
          this.showSimpleModal = true;
          this.showDetailsModal = false;
        }

      }else {
        if(isCurrent){
          this.showCardMsg = false;
          this.showCardGm = true;
          this.showCardDetailsGm = false;
          this.showCardSimpleGm = true;
          this.showButton = false; 
          this.showSimpleModal = true;
          this.showDetailsModal = false;
        } else {
          this.showCardMsg = false;
          this.showCardGm = true;
          this.showCardDetailsGm = false;
          this.showCardSimpleGm = true;
          this.showButton = true; 
          this.showSimpleModal = true;
          this.showDetailsModal = false;
        }
      }
    },

    formatDateVigence(date){
      let parts = this.formatDate(date).split('/');

      let today = new Date();
      let todayParts = today.toLocaleDateString('pt-BR').split('/');

      let formatDateToday = new Date(parts[2], parts[1] - 1, parts[0]);
      today = new Date(todayParts[2], todayParts[1] - 1, todayParts[0]);

      return formatDateToday >= today ? true : false;
    },

  },
};
</script>

<style lang="scss" scoped>
#jns {
  .v-card__title {
    width: 100%;
    background-color: #efefef;
    font-size: 14px;
    font-weight: bolder;

    color: #191737;
    margin-bottom: 20px;
  }

  .box-cards {
    width: 100%;
    display: flex;
    flex-direction: column;

    .card-height {
      .layout {
        width: 100%;
        .tablec {
          width: 100% !important;
        }
      }
    }

    .box-card-limite-global {
      display: flex;
      margin: 0 0 2% 0;

      .box-card-global {
        width: 69%;
        display: flex;
        flex-direction: column;
        flex-shrink: 1;
        flex-grow: 1;

        .card-height {
          display: flex;
          align-items: center;
          justify-content: center;

          .card-g {
            display: flex;
            width: 100%;
            justify-content: space-around;
            text-align: center;
          }

          @media screen and (max-width: 835px) {
            .card-g {
              display: flex;
              flex-direction: column;
              flex-wrap: wrap;
            }

            .card-g > div {
              margin: 0 0 2% 0;
            }
          }
        }
      }

      @media screen and (max-width: 760px) {
        .box-card-global {
          width: 100%;
        }
      }

      .box-button-global {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-att-cad {
          width: 80%;
        }
      }

      .box-msg-global {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1%;
        text-align: justify;
        font-size: 1rem;
        background-color: #efefef;
        color: #191737;
        border: 1px solid #efefef;
        box-shadow: 3px 6px 5px -5px rgba(0, 0, 0, 0.56);
        border-radius: 3px;
        margin-left: 1%;
      }

      @media screen and (max-width: 760px) {
        flex-direction: column;

        .box-button-global {
          width: 100%;
          margin: 2% 0 0 0;

          .btn-att-cad {
            width: 100%;
          }
        }

        .box-msg-global {
          width: 100%;
          height: auto;
          margin: 2% 0 0 0;
        }
      }
    }

    .card-int {
      display: flex;
      flex-wrap: wrap;
    }

    @media screen and(max-width: 910px) {
      .card-int {
        font-size: 0.8rem;
      }
    }

    @media screen and(max-width: 541px) {
      .card-int {
        font-size: 0.7rem;
      }
    }

    @media screen and(max-width: 361px) {
      .card-int {
        font-size: 0.5rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/TomadorLimitesTaxas.vue